import {ApplicationRef, ComponentFactory, ComponentFactoryResolver, Injectable, Type} from '@angular/core';

import {ModalContainerComponent} from './components/modal-container/modal-container.component';
import {ModalRef} from './models/modal-ref.model';

@Injectable({
    providedIn: 'root'
})
export class ModalService {

    private modalContainer: HTMLElement;
    private modalContainerFactory: ComponentFactory<ModalContainerComponent>;

    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private modalRef: ModalRef,
        private appRef: ApplicationRef
    ) {
        this.setupModalContainerFactory();
    }

    open<T>({content: component, componentParams: componentParams, modalOptions: modalOptions}): ModalRef {
        this.setupModalContainerDiv();

        const modalContainerRef = this.appRef.bootstrap(this.modalContainerFactory, this.modalContainer);

        const modalComponentRef = modalContainerRef.instance.createModal(component);

        Object.keys(componentParams).map(key => {
            modalComponentRef.instance[key] = componentParams[key];
        });
        Object.keys(modalOptions).map(key => {
          modalContainerRef.instance[key] = modalOptions[key];
        });

        this.modalRef.setModalRef(modalComponentRef);

        this.modalRef.setModalComponentRef(modalContainerRef);

        return this.modalRef;
    }

    private setupModalContainerDiv(): void {
        this.modalContainer = document.createElement('div');
        document.getElementsByTagName('body')[0].appendChild(this.modalContainer);
    }

    private setupModalContainerFactory(): void {
        this.modalContainerFactory = this.componentFactoryResolver.resolveComponentFactory(ModalContainerComponent);
    }
}
